import React, { useRef, useState } from 'react';
import { FiUpload, FiPlay, FiSquare, FiRotateCcw, FiLoader, FiMic } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { uploadAvatarImage } from '../../services/uploadService';
import { CONNECTION_STATES } from '../../constants';
import './SessionControls.css';

export function SessionControls({
  connectionStatus,
  onConnect,
  onDisconnect,
  onResetChat,
  avatarUrl,
  onAvatarUploaded,
}) {
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const isConnected = connectionStatus === CONNECTION_STATES.CONNECTED || connectionStatus === CONNECTION_STATES.TALKING;
  const isConnecting = connectionStatus === CONNECTION_STATES.CONNECTING;

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const localUrl = URL.createObjectURL(file);
    setIsUploading(true);
    try {
      const secureUrl = await uploadAvatarImage(file);
      onAvatarUploaded(secureUrl, localUrl);
      toast.success('Avatar uploaded.');
    } catch (err) {
      toast.error('Upload failed. Try again.');
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  return (
    <div className="session-controls">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/jpg,image/png,image/webp"
        className="hidden-file-input"
        onChange={handleFileSelect}
      />

      {/* Upload Photo — ghost pill */}
      {!isConnected && (
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => fileInputRef.current?.click()}
          disabled={isUploading || isConnecting}
        >
          {isUploading
            ? <><FiLoader className="btn-icon spin" /><span>Uploading…</span></>
            : <><FiUpload className="btn-icon" /><span>Upload photo</span></>
          }
        </button>
      )}

      {/* Start / End Session — primary gradient */}
      {!isConnected ? (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onConnect}
          disabled={isConnecting || isUploading}
        >
          {isConnecting
            ? <><FiLoader className="btn-icon spin" /><span>Connecting…</span></>
            : <><FiPlay className="btn-icon" /><span>Start session</span></>
          }
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-primary is-live"
          onClick={onDisconnect}
        >
          <FiSquare className="btn-icon" />
          <span>End session</span>
        </button>
      )}

      {/* Clear chat — icon dock button */}
      <button
        type="button"
        className="btn-dock-icon"
        onClick={onResetChat}
        title="Clear conversation"
      >
        <FiRotateCcw size={15} />
      </button>
    </div>
  );
}
